function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2 0.839844C9.06584 0.839844 0.0400391 9.86564 0.0400391 20.9998C0.0400391 32.134 9.06584 41.1598 20.2 41.1598C31.3342 41.1598 40.36 32.134 40.36 20.9998C40.36 9.86564 31.3342 0.839844 20.2 0.839844ZM15.265 29.3557H11.1826V16.2181H15.265V29.3557ZM13.1986 14.6053C11.9092 14.6053 11.0755 13.6918 11.0755 12.562C11.0755 11.4091 11.9344 10.5229 13.2511 10.5229C14.5678 10.5229 15.3742 11.4091 15.3994 12.562C15.3994 13.6918 14.5678 14.6053 13.1986 14.6053ZM30.175 29.3557H26.0926V22.075C26.0926 20.3803 25.5004 19.2295 24.0241 19.2295C22.8964 19.2295 22.2265 20.0086 21.9304 20.7583C21.8212 21.025 21.7939 21.403 21.7939 21.7789V29.3536H17.7094V20.4076C17.7094 18.7675 17.6569 17.3962 17.6023 16.216H21.1492L21.3361 18.0409H21.418C21.9556 17.1841 23.2723 15.9199 25.4752 15.9199C28.1611 15.9199 30.175 17.7196 30.175 21.5878V29.3557Z",
  fill: "white"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.20150b32.svg";
export { ForwardRef as ReactComponent };